export const REPORTS_PAGE_ROUTE = "/reports";
export const CATALOG_PAGE_ROUTE = "/catalog";
export const ADD_ITEM_PAGE_ROUTE = "/add-item";
export const ADD_ITEM_VARIANT_PAGE_ROUTE = "/add-item-variant";
export const DASHBOARD_PAGE_ROUTE = "/dashboard";
export const LOGIN_PAGE_ROUTE = "/login";
export const BASE_MENU_PAGE_ROUTE = CATALOG_PAGE_ROUTE + "/baseMenu";
export const REDIRECT_PAGE_ROUTE = "/redirect_page";
export const NOT_FOUND_ROUTE = "/404";
export const OUTLET_STATUS_PAGE_ROUTE = "/outlet-status";
export const ACCOUNTING_PAGE_ROUTE = "/accounting";
export const DOWNLOADS_PAGE_ROUTE = "/downloads";
export const TABLES_PAGE_ROUTE = '/tables';
export const CASH_MANAGEMENT_ROUTE = "/accounting/cash_management";
export const CASHIER_SETTLEMENT_ROUTE = '/accounting/cashier_settlement';
export const PNL_STATEMENT_ROUTE = '/accounting/pnl_statement';
export const SALES_AUDIT_PAGE_ROUTE = 'accounting/sales-audit';
export const ACCOUNT_SUMMARY_PAGE_ROUTE = 'accounting/account-summary';
export const SUPPORT_LOGIN_ROUTE = "/support-login";
export const FINANCE_INVENTORY_MODULE = "/finance-inventory-module";